module.exports = __webpack_public_path__ + "img/B_logo.b101a15f.png";